webpackJsonp([195103172586735],{

/***/ 473:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Arnel Campos","designation":null,"thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/1JSJ2TYuIIQICSiMsQOOc0/7029d0c1131d8f8cc3089883bce9013f/Arnel.jpg"}},"content":{"content":"Manila Street Astronomers Arnel Campos with his wife Michelle help MSA reach out to people located south of Metro Manila.\n\nArnel is an astrophotographer and amateur astronomer with interests in general astronomy and astronomy documentaries (especially the ones hosted by Dr. Neil deGrasse Tyson & Prof. Brian Cox). He is a graphic designer and runs a printing press business in Cavite. Arnel usually volunteers for MSA events in Cavite and Laguna, in locations such as SM Dasmariñas and at the Paseo de Sta Rosa.\n\nWearing his signature hat, Arnel is also known as the \"Astro Cowboy\" of the Astronomical League of the Philippines, a local astrophotography group.\n\nYou, too, can be a volunteer astronomer. Join us!"}}},"pathContext":{"id":"pxp6p8o52g4e60EU8G6O"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-arnel-campos-9ef868dca4466cd9e612.js